import { useQueryClient } from '@tanstack/react-query'
import { Field, Label } from '@zendeskgarden/react-forms'
import { Body, Close, Footer, FooterItem, Header, Modal } from '@zendeskgarden/react-modals'
import React, { useCallback, useState } from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import LeftArrow from '../../icons/left-arrow.svg?react'
import { RecordFactory } from '../../models/RecordFactory'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { PSButton, PSButtonPrimary } from '../app/PSButton'
import { PSTextarea } from '../app/PSTextarea'
import { SelectOption, cancellationReasonOptions } from '../settings/Options'

type LocationStateType = {
    reason?: SelectOption
}

const viewWillAppear = async (base: PocketComponent) => {
    const locationState = base.locationState as LocationStateType | undefined

    if (!locationState?.reason) {
        return new RecordNotFoundError()
    }

    return { reason: locationState.reason.value }
}

const render = ({ data, base }: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const user = base.me
    const navigate = usePSNavigate()
    const queryClient = useQueryClient()

    const [details, setDetails] = useState('')

    const handleDone = useCallback(async () => {
        if (!user) return

        const result = await RecordFactory.getInstance().cancelPremium(user, data.reason, details)
        if (!result.ok) {
            base.logAndDisplayError(result.error)
            return
        }

        queryClient.invalidateQueries({ queryKey: ['account-switcher-users'] })
        if (result.value.numberOfRoles > 0) {
            navigate('/login/accounts', { replace: true })
            return
        }

        navigate('/?showCancellationDone=true')
    }, [details])

    return (
        <>
            <div className="supportSettings">
                <div className="header">
                    <PSButton className="left" onClick={() => navigate(-1)}>
                        <LeftArrow />
                    </PSButton>
                    <h1 className="title">Please tell us more!</h1>
                    <div className="right">
                        <PSButtonPrimary disabled={!details} onClick={handleDone}>
                            Done
                        </PSButtonPrimary>
                    </div>
                </div>
                <div className="separator" />
                <div className="form">
                    <Field className="field">
                        <Label className="label">We love feedback!</Label>
                        <PSTextarea
                            placeholder="Please enter"
                            className="input"
                            minRows={5}
                            maxLength={999}
                            value={details}
                            onChange={(value) => setDetails(value)}
                        />
                    </Field>
                </div>
            </div>
        </>
    )
}
export const DowngradeConfirmationPage = usePSComponent(render, viewWillAppear)
